import React from 'react';
import { FuelGridItem } from '@frete.com/fuel-react';
import { ButtonSkeleton, ParagraphSkeleton, Skeleton, TextFieldSkeleton } from '@/components';
import { Container, ProgressContainer, StepsContainer } from './styled';
import { FormContainer, FormItem, FormRow } from '@/components/FormWrapper/Steps';

export const PageWrapperSkeleton: React.FC = () => (
  <Container>
    <FuelGridItem style={{ marginBottom: '0.75rem' }}>
      <ParagraphSkeleton width="20rem" height="2rem" />
    </FuelGridItem>
    <FuelGridItem>
      <ProgressContainer>
        <Skeleton height="0.25rem" width="100%" />
        <StepsContainer>
          <Skeleton height="1.5rem" width="5rem" />
          <Skeleton height="1.5rem" width="9rem" />
          <Skeleton height="1.5rem" width="4rem" />
        </StepsContainer>
      </ProgressContainer>
    </FuelGridItem>
    <FuelGridItem>
      <FormContainer>
        <FormRow>
          <FormItem sm={4} md={4} lg={4} style={{ gap: '1rem' }}>
            <Skeleton width="4rem" height="1rem" />
            <Skeleton width="30rem" height="1.75rem" />
          </FormItem>
        </FormRow>
        <FormRow style={{ alignItems: 'end' }}>
          <FormItem>
            <TextFieldSkeleton label />
          </FormItem>
          <FormItem>
            <TextFieldSkeleton label />
          </FormItem>
          <FormItem>
            <ButtonSkeleton width="6.75rem" />
          </FormItem>
        </FormRow>
        <FormRow>
          <FormItem md={2} lg={2}>
            <TextFieldSkeleton label />
          </FormItem>
        </FormRow>
        <FormRow>
          <FormItem>
            <TextFieldSkeleton label />
          </FormItem>
          <FormItem>
            <TextFieldSkeleton label />
          </FormItem>
          <FormItem>
            <TextFieldSkeleton label />
          </FormItem>
          <FormItem>
            <TextFieldSkeleton label />
          </FormItem>
        </FormRow>
        <FormRow>
          <FormItem>
            <TextFieldSkeleton label />
          </FormItem>
          <FormItem>
            <TextFieldSkeleton label />
          </FormItem>
          <FormItem>
            <TextFieldSkeleton label />
          </FormItem>
        </FormRow>
        <FormRow>
          <FormItem>
            <TextFieldSkeleton label />
          </FormItem>
          <FormItem>
            <TextFieldSkeleton label />
          </FormItem>
        </FormRow>
        <FormRow>
          <FormItem>
            <TextFieldSkeleton label />
          </FormItem>
        </FormRow>
        <FormRow>
          <FormItem>
            <TextFieldSkeleton label />
          </FormItem>
          <FormItem>
            <TextFieldSkeleton label />
          </FormItem>
          <FormItem>
            <TextFieldSkeleton label />
          </FormItem>
          <FormItem>
            <TextFieldSkeleton label />
          </FormItem>
        </FormRow>
      </FormContainer>
    </FuelGridItem>
  </Container>
);
